export enum LOGIN_TYPE {
  PHONE = 0,
  VERIFY_CODE = 1,
  EMAIL = 2,
}

export enum STATION_AUTH {
  VIEW = 0,
  MANAGE = 1,
  TRANSFER = 2,
  EDIT = 3,
}

export enum SHARE_TYPE {
  EMAIL = 0,
  PHONE = 1,
}

export enum TARIFF_TYPE {
  FIXED = 'fixed',
  TERM_OF_USE = 'tou',
  TERM_OF_USE_WEEKDAY_WEEKEND = 'touW',
}

export const tariffTypeLists = [
  {
    value: TARIFF_TYPE.FIXED,
    label: 'site.fixed',
  },
  {
    value: TARIFF_TYPE.TERM_OF_USE,
    label: 'site.tou',
  },
  {
    value: TARIFF_TYPE.TERM_OF_USE_WEEKDAY_WEEKEND,
    label: 'site.touW',
  },
]

export enum COLLECT_TYPE {
  COLLECT = 1, // 收藏
  NOT_COLLECT = 0, // 不收藏
}

export enum SITE_STATUS {
  ALL = 0, // 全部
  NORMAL = 1, // 正常
  OFFLINE = 2, // 离线
  WARNING = 3, // 警告
  FAULT = 4, // 故障
  FAVOURITE = 5, // 收藏
}

export const siteStatusLists = [
  {
    value: SITE_STATUS.ALL,
    label: 'all',
  },
  {
    value: SITE_STATUS.NORMAL,
    label: 'online',
  },
  {
    value: SITE_STATUS.OFFLINE,
    label: 'offline',
  },
  {
    value: SITE_STATUS.WARNING,
    label: 'warning',
  },
  {
    value: SITE_STATUS.FAULT,
    label: 'fault',
  },
  {
    value: SITE_STATUS.FAVOURITE,
    label: 'favourite',
  },
]

export const areaCodeLists = [
  {
    value: '+93',
    cn: '阿富汗',
    en: 'Afghanistan',
  },
  {
    value: '+355',
    cn: '阿尔巴尼亚',
    en: 'Albania',
  },
  {
    value: '+213',
    cn: '阿尔及利亚',
    en: 'Algeria',
  },
  {
    value: '+1684',
    cn: '美属萨摩亚',
    en: 'American Samoa',
  },
  {
    value: '+376',
    cn: '安道尔',
    en: 'Andorra',
  },
  {
    value: '+244',
    cn: '安哥拉',
    en: 'Angola',
  },
  {
    value: '+1264',
    cn: '安圭拉岛',
    en: 'Anguilla Island',
  },
  {
    value: '+0',
    cn: '南极洲',
    en: 'Antarctica',
  },
  {
    value: '+1268',
    cn: '安提瓜岛和巴布达',
    en: 'Antigua and Barbuda',
  },
  {
    value: '+54',
    cn: '阿根廷',
    en: 'Argentina',
  },
  {
    value: '+374',
    cn: '亚美尼亚',
    en: 'Armenia',
  },
  {
    value: '+297',
    cn: '阿鲁巴岛',
    en: 'Aruba Island',
  },
  {
    value: '+61',
    cn: '澳大利亚',
    en: 'Australia',
  },
  {
    value: '+43',
    cn: '奥地利',
    en: 'Austria',
  },
  {
    value: '+994',
    cn: '阿塞拜疆',
    en: 'Azerbaijan',
  },
  {
    value: '+1242',
    cn: '巴哈马群岛',
    en: 'The Bahamas',
  },
  {
    value: '+973',
    cn: '巴林',
    en: 'Bahrain',
  },
  {
    value: '+880',
    cn: '孟加拉国',
    en: 'Bangladesh',
  },
  {
    value: '+1246',
    cn: '巴巴多斯',
    en: 'Barbados',
  },
  {
    value: '+375',
    cn: '白俄罗斯',
    en: 'Belarus',
  },
  {
    value: '+32',
    cn: '比利时',
    en: 'Belgium',
  },
  {
    value: '+501',
    cn: '伯利兹',
    en: 'Belize',
  },
  {
    value: '+229',
    cn: '贝宁',
    en: 'Benin',
  },
  {
    value: '+1441',
    cn: '百慕大',
    en: 'Bermuda',
  },
  {
    value: '+975',
    cn: '不丹',
    en: 'Bhutan',
  },
  {
    value: '+591',
    cn: '玻利维亚',
    en: 'Bolivia',
  },
  {
    value: '+387',
    cn: '波斯尼亚和黑塞哥维那',
    en: 'Bosnia and Herzegovina',
  },
  {
    value: '+267',
    cn: '博茨瓦纳',
    en: 'Botswana',
  },
  {
    value: '+0',
    cn: '布维岛',
    en: 'Bouvet Island',
  },
  {
    value: '+55',
    cn: '巴西',
    en: 'Brazil',
  },
  {
    value: '+246',
    cn: '英属印度洋领地',
    en: 'British Indian Ocean Territory',
  },
  {
    value: '+673',
    cn: '文莱达鲁萨兰国',
    en: 'Brunei Darussalam',
  },
  {
    value: '+359',
    cn: '保加利亚',
    en: 'Bulgaria',
  },
  {
    value: '+226',
    cn: '布吉纳法索',
    en: 'Burkina Faso',
  },
  {
    value: '+257',
    cn: '布隆迪',
    en: 'Burundi',
  },
  {
    value: '+855',
    cn: '柬埔寨',
    en: 'Cambodia',
  },
  {
    value: '+237',
    cn: '喀麦隆',
    en: 'Cameroon',
  },
  {
    value: '+1',
    cn: '加拿大',
    en: 'Canada',
  },
  {
    value: '+238',
    cn: '佛得角',
    en: 'Cape Verde',
  },
  {
    value: '+1345',
    cn: '开曼群岛',
    en: 'The Cayman Islands',
  },
  {
    value: '+236',
    cn: '中非共和国',
    en: 'Central African Republic',
  },
  {
    value: '+235',
    cn: '乍得',
    en: 'Chad',
  },
  {
    value: '+56',
    cn: '智利',
    en: 'Chile',
  },
  {
    value: '+86',
    cn: '中国',
    en: 'China',
  },
  {
    value: '+61',
    cn: '圣诞岛',
    en: 'Christmas Island',
  },
  {
    value: '+672',
    cn: 'COCOS(KEELING)岛',
    en: 'COCOS (KEELING) Island',
  },
  {
    value: '+57',
    cn: '哥伦比亚',
    en: 'Colombia',
  },
  {
    value: '+269',
    cn: '科摩罗',
    en: 'Comoros',
  },
  {
    value: '+242',
    cn: '刚果',
    en: 'Congo',
  },
  {
    value: '+242',
    cn: '刚果民主共和国的',
    en: 'The Democratic Republic of Congo',
  },
  {
    value: '+682',
    cn: '库克群岛',
    en: 'The Cook Islands',
  },
  {
    value: '+506',
    cn: '哥斯达黎加',
    en: 'Costa Rica',
  },
  {
    value: '+225',
    cn: '科特迪瓦',
    en: 'Ivory Coast',
  },
  {
    value: '+385',
    cn: '克罗地亚',
    en: 'Croatia',
  },
  {
    value: '+53',
    cn: '古巴',
    en: 'Cuba',
  },
  {
    value: '+357',
    cn: '塞浦路斯',
    en: 'Cyprus',
  },
  {
    value: '+420',
    cn: '捷克共和国',
    en: 'The Czech Republic',
  },
  {
    value: '+45',
    cn: '丹麦',
    en: 'Denmark',
  },
  {
    value: '+253',
    cn: '吉布提',
    en: 'Djibouti',
  },
  {
    value: '+1767',
    cn: '多米尼加',
    en: 'The Dominican Republic',
  },
  {
    value: '+1809',
    cn: '多米尼加共和国',
    en: 'The Dominican Republic',
  },
  {
    value: '+593',
    cn: '厄瓜多尔',
    en: 'Ecuador',
  },
  {
    value: '+20',
    cn: '埃及',
    en: 'Egypt',
  },
  {
    value: '+503',
    cn: '萨尔瓦多',
    en: 'El Salvador',
  },
  {
    value: '+240',
    cn: '赤道几内亚',
    en: 'Equatorial Guinea',
  },
  {
    value: '+291',
    cn: '厄立特里亚',
    en: 'Eritrea',
  },
  {
    value: '+372',
    cn: '爱沙尼亚',
    en: 'Estonia',
  },
  {
    value: '+251',
    cn: '埃塞俄比亚',
    en: 'Ethiopia',
  },
  {
    value: '+500',
    cn: '福克兰群岛(马尔维纳斯)',
    en: 'The Falkland Islands (Malvinas)',
  },
  {
    value: '+298',
    cn: '法罗群岛',
    en: 'The Faroe Islands',
  },
  {
    value: '+679',
    cn: '斐济',
    en: 'Fiji',
  },
  {
    value: '+358',
    cn: '芬兰',
    en: 'Finland',
  },
  {
    value: '+33',
    cn: '法国',
    en: 'France',
  },
  {
    value: '+594',
    cn: '法属圭亚那',
    en: 'French Guiana',
  },
  {
    value: '+689',
    cn: '法属波利尼西亚',
    en: 'French Polynesia',
  },
  {
    value: '+0',
    cn: '法国南部地区',
    en: 'The southern region of France',
  },
  {
    value: '+241',
    cn: '加蓬',
    en: 'Gabon',
  },
  {
    value: '+220',
    cn: '冈比亚',
    en: 'The Gambia',
  },
  {
    value: '+995',
    cn: '乔治亚州',
    en: 'Georgia',
  },
  {
    value: '+49',
    cn: '德国',
    en: 'Germany',
  },
  {
    value: '+233',
    cn: '加纳',
    en: 'Ghana',
  },
  {
    value: '+350',
    cn: '直布罗陀',
    en: 'Gibraltar',
  },
  {
    value: '+30',
    cn: '希腊',
    en: 'Greece',
  },
  {
    value: '+299',
    cn: '格陵兰岛',
    en: 'Greenland',
  },
  {
    value: '+1473',
    cn: '格林纳达',
    en: 'Grenada',
  },
  {
    value: '+590',
    cn: '瓜德罗普岛',
    en: 'Guadeloupe Island',
  },
  {
    value: '+1671',
    cn: '关岛',
    en: 'Guam',
  },
  {
    value: '+502',
    cn: '危地马拉',
    en: 'Guatemala',
  },
  {
    value: '+224',
    cn: '几内亚',
    en: 'Guinea',
  },
  {
    value: '+245',
    cn: '几内亚比绍',
    en: 'Guinea Bissau',
  },
  {
    value: '+592',
    cn: '圭亚那',
    en: 'Guyana',
  },
  {
    value: '+509',
    cn: '海地',
    en: 'Haiti',
  },
  {
    value: '+0',
    cn: '听到岛和麦当劳的岛屿',
    en: 'Heard Island and McDonald Islands',
  },
  {
    value: '+39',
    cn: '教廷(梵蒂冈)',
    en: 'The Holy See (Vatican)',
  },
  {
    value: '+504',
    cn: '洪都拉斯',
    en: 'Honduras',
  },
  {
    value: '+852',
    cn: '中国香港',
    en: 'Hong Kong, China',
  },
  {
    value: '+36',
    cn: '匈牙利',
    en: 'Hungary',
  },
  {
    value: '+354',
    cn: '冰岛',
    en: 'Iceland',
  },
  {
    value: '+91',
    cn: '印度',
    en: 'India',
  },
  {
    value: '+62',
    cn: '印尼',
    en: 'Indonesia',
  },
  {
    value: '+98',
    cn: '伊朗伊斯兰共和国',
    en: 'Islamic Republic of Iran',
  },
  {
    value: '+964',
    cn: '伊拉克',
    en: 'Iraq',
  },
  {
    value: '+353',
    cn: '爱尔兰',
    en: 'Ireland',
  },
  {
    value: '+972',
    cn: '以色列',
    en: 'Israel',
  },
  {
    value: '+39',
    cn: '意大利',
    en: 'Italy',
  },
  {
    value: '+1876',
    cn: '牙买加',
    en: 'Jamaica',
  },
  {
    value: '+81',
    cn: '日本',
    en: 'Japan',
  },
  {
    value: '+962',
    cn: '约旦',
    en: 'Jordan',
  },
  {
    value: '+7',
    cn: '哈萨克斯坦',
    en: 'Kazakhstan',
  },
  {
    value: '+254',
    cn: '肯尼亚',
    en: 'Kenya',
  },
  {
    value: '+686',
    cn: '基里巴斯',
    en: 'Kiribati',
  },
  {
    value: '+850',
    cn: '朝鲜民主主义人民共和国',
    en: "The Democratic People's Republic of Korea",
  },
  {
    value: '+82',
    cn: '朝鲜共和国',
    en: 'The Republic of Korea',
  },
  {
    value: '+965',
    cn: '科威特',
    en: 'Kuwait',
  },
  {
    value: '+996',
    cn: '吉尔吉斯斯坦',
    en: 'Kyrgyzstan',
  },
  {
    value: '+856',
    cn: '老挝人民民主共和国',
    en: "Lao People's Democratic Republic",
  },
  {
    value: '+371',
    cn: '拉脱维亚',
    en: 'Latvia',
  },
  {
    value: '+961',
    cn: '黎巴嫩',
    en: 'Lebanon',
  },
  {
    value: '+266',
    cn: '莱索托',
    en: 'Lesotho',
  },
  {
    value: '+231',
    cn: '利比里亚',
    en: 'Liberia',
  },
  {
    value: '+218',
    cn: '阿拉伯利比亚民众国',
    en: 'The Libyan Arab Emirates',
  },
  {
    value: '+423',
    cn: '列支敦斯登',
    en: 'Liechtenstein',
  },
  {
    value: '+370',
    cn: '立陶宛',
    en: 'Lithuania',
  },
  {
    value: '+352',
    cn: '卢森堡',
    en: 'Luxembourg',
  },
  {
    value: '+853',
    cn: '澳门',
    en: 'Macau',
  },
  {
    value: '+389',
    cn: '前南斯拉夫马其顿共和国',
    en: 'The former Yugoslav Republic of Macedonia',
  },
  {
    value: '+261',
    cn: '马达加斯加',
    en: 'Madagascar',
  },
  {
    value: '+265',
    cn: '马拉维',
    en: 'Malawi',
  },
  {
    value: '+60',
    cn: '马来西亚',
    en: 'Malaysia',
  },
  {
    value: '+960',
    cn: '马尔代夫',
    en: 'Maldives',
  },
  {
    value: '+223',
    cn: '马里',
    en: 'Mali',
  },
  {
    value: '+356',
    cn: '马耳他',
    en: 'Malta',
  },
  {
    value: '+692',
    cn: '马绍尔群岛',
    en: 'The Marshall Islands',
  },
  {
    value: '+596',
    cn: '马提尼克岛',
    en: 'Martinique Island',
  },
  {
    value: '+222',
    cn: '毛利塔尼亚',
    en: 'Mauritania',
  },
  {
    value: '+230',
    cn: '毛里求斯',
    en: 'Mauritius',
  },
  {
    value: '+269',
    cn: '马约特岛',
    en: 'Mayotte Island',
  },
  {
    value: '+52',
    cn: '墨西哥',
    en: 'Mexico',
  },
  {
    value: '+691',
    cn: '密克罗尼西亚联邦',
    en: 'Federated States of Micronesia',
  },
  {
    value: '+373',
    cn: '摩尔多瓦共和国',
    en: 'The Republic of Moldova',
  },
  {
    value: '+377',
    cn: '摩纳哥',
    en: 'Monaco',
  },
  {
    value: '+976',
    cn: '蒙古',
    en: 'Mongolia',
  },
  {
    value: '+1664',
    cn: '蒙特塞拉特',
    en: 'Montserrat',
  },
  {
    value: '+212',
    cn: '摩洛哥',
    en: 'Morocco',
  },
  {
    value: '+258',
    cn: 'MOZAMBIQUE',
    en: 'MOZAMBIQUE',
  },
  {
    value: '+95',
    cn: '缅甸',
    en: 'Myanmar',
  },
  {
    value: '+264',
    cn: '纳米比亚',
    en: 'Namibia',
  },
  {
    value: '+674',
    cn: '瑙鲁',
    en: 'Nauru',
  },
  {
    value: '+977',
    cn: '尼泊尔',
    en: 'Nepal',
  },
  {
    value: '+31',
    cn: '荷兰',
    en: 'The Netherlands',
  },
  {
    value: '+599',
    cn: '荷属安的列斯群岛',
    en: 'The Netherlands Antilles',
  },
  {
    value: '+687',
    cn: '新喀里多尼亚',
    en: 'New Caledonia',
  },
  {
    value: '+64',
    cn: '新西兰',
    en: 'New Zealand',
  },
  {
    value: '+505',
    cn: '尼加拉瓜',
    en: 'Nicaragua',
  },
  {
    value: '+227',
    cn: '尼日尔',
    en: 'Niger',
  },
  {
    value: '+234',
    cn: '尼日利亚',
    en: 'Nigeria',
  },
  {
    value: '+683',
    cn: '纽埃岛',
    en: 'Niue Island',
  },
  {
    value: '+672',
    cn: '诺福克岛',
    en: 'Norfolk Island',
  },
  {
    value: '+1670',
    cn: '北马里亚纳群岛',
    en: 'The Northern Mariana Islands',
  },
  {
    value: '+47',
    cn: '挪威',
    en: 'Norway',
  },
  {
    value: '+968',
    cn: '阿曼',
    en: 'Oman',
  },
  {
    value: '+92',
    cn: '巴基斯坦',
    en: 'Pakistan',
  },
  {
    value: '+680',
    cn: '帕劳',
    en: 'Palau',
  },
  {
    value: '+970',
    cn: '巴勒斯坦的领土,占领',
    en: 'Palestinian territories,occupation',
  },
  {
    value: '+507',
    cn: '巴拿马',
    en: 'Panama',
  },
  {
    value: '+675',
    cn: '巴布新几内亚',
    en: 'Papua New Guinea',
  },
  {
    value: '+595',
    cn: '巴拉圭',
    en: 'Paraguay',
  },
  {
    value: '+51',
    cn: '秘鲁',
    en: 'Peru',
  },
  {
    value: '+63',
    cn: '菲律宾',
    en: 'The Philippines',
  },
  {
    value: '+0',
    cn: '皮特克恩',
    en: 'Peter Cohen',
  },
  {
    value: '+48',
    cn: '波兰',
    en: 'Poland',
  },
  {
    value: '+351',
    cn: '葡萄牙',
    en: 'Portugal',
  },
  {
    value: '+1787',
    cn: '波多黎各',
    en: 'Puerto Rico',
  },
  {
    value: '+974',
    cn: '卡塔尔',
    en: 'Qatar',
  },
  {
    value: '+262',
    cn: '团聚',
    en: 'Reunion',
  },
  {
    value: '+40',
    cn: '罗马尼亚',
    en: 'Romania',
  },
  {
    value: '+70',
    cn: '俄罗斯联邦',
    en: 'The Russian Federation',
  },
  {
    value: '+250',
    cn: '卢旺达',
    en: 'Rwanda',
  },
  {
    value: '+290',
    cn: '圣赫勒拿',
    en: 'Saint Helena',
  },
  {
    value: '+1869',
    cn: '圣基茨和尼维斯',
    en: 'Saint Kitts and Nevis',
  },
  {
    value: '+1758',
    cn: '圣卢西亚岛',
    en: 'Saint Lucia Island',
  },
  {
    value: '+508',
    cn: '圣皮埃尔和MIQUELON',
    en: 'Saint Pierre and MIQUELON',
  },
  {
    value: '+1784',
    cn: '圣文森特和格林纳丁斯',
    en: 'Saint Vincent and the Grenadines',
  },
  {
    value: '+684',
    cn: '萨摩亚',
    en: 'Samoa',
  },
  {
    value: '+378',
    cn: '圣马力诺',
    en: 'San Marino',
  },
  {
    value: '+239',
    cn: '圣多美和王子',
    en: 'Sao Tome and the Prince',
  },
  {
    value: '+966',
    cn: '沙特阿拉伯',
    en: 'Saudi Arabia',
  },
  {
    value: '+221',
    cn: '塞内加尔',
    en: 'Senegal',
  },
  {
    value: '+381',
    cn: '塞尔维亚和黑山',
    en: 'Serbia and Montenegro',
  },
  {
    value: '+248',
    cn: '塞舌尔',
    en: 'Seychelles',
  },
  {
    value: '+232',
    cn: '塞拉利昂',
    en: 'Sierra Leone',
  },
  {
    value: '+65',
    cn: '新加坡',
    en: 'Singapore',
  },
  {
    value: '+421',
    cn: '斯洛伐克',
    en: 'Slovakia',
  },
  {
    value: '+386',
    cn: '斯洛文尼亚',
    en: 'Slovenia',
  },
  {
    value: '+677',
    cn: '所罗门群岛',
    en: 'The Solomon Islands',
  },
  {
    value: '+252',
    cn: '索马里',
    en: 'Somalia',
  },
  {
    value: '+27',
    cn: '南非',
    en: 'South Africa',
  },
  {
    value: '+0',
    cn: '南乔治亚岛和南桑威奇群岛',
    en: 'South Georgia and the South Sandwich Islands',
  },
  {
    value: '+34',
    cn: '西班牙',
    en: 'Spain',
  },
  {
    value: '+94',
    cn: '斯里兰卡',
    en: 'Sri Lanka',
  },
  {
    value: '+249',
    cn: '苏丹',
    en: 'Sudan',
  },
  {
    value: '+597',
    cn: '苏里南',
    en: 'Suriname',
  },
  {
    value: '+47',
    cn: '斯瓦尔巴群岛和扬马延岛',
    en: 'Svalbard and Jan Mayen Islands',
  },
  {
    value: '+268',
    cn: '斯威士兰',
    en: 'Eswatini',
  },
  {
    value: '+46',
    cn: '瑞典',
    en: 'Sweden',
  },
  {
    value: '+41',
    cn: '瑞士',
    en: 'Switzerland',
  },
  {
    value: '+963',
    cn: '阿拉伯叙利亚共和国',
    en: 'The Syrian Arab Republic',
  },
  {
    value: '+886',
    cn: '中国台湾地区',
    en: 'Taiwan, China',
  },
  {
    value: '+992',
    cn: '塔吉克斯坦',
    en: 'Tajikistan',
  },
  {
    value: '+255',
    cn: '坦桑尼亚联合共和国',
    en: 'United Republic of Tanzania',
  },
  {
    value: '+66',
    cn: '泰国',
    en: 'Thailand',
  },
  {
    value: '+670',
    cn: '东帝汶',
    en: 'East Timor',
  },
  {
    value: '+228',
    cn: '多哥',
    en: 'Togo',
  },
  {
    value: '+690',
    cn: '托克劳',
    en: 'Tokelaua',
  },
  {
    value: '+676',
    cn: '汤加',
    en: 'Tonga',
  },
  {
    value: '+1868',
    cn: '特立尼达和多巴哥',
    en: 'Trinidad and Tobago',
  },
  {
    value: '+216',
    cn: '突尼斯',
    en: 'Tunisia',
  },
  {
    value: '+90',
    cn: '土耳其',
    en: 'Turkey',
  },
  {
    value: '+7370',
    cn: '土库曼斯坦',
    en: 'Turkmenistan',
  },
  {
    value: '+1649',
    cn: '特克斯和凯科斯群岛',
    en: 'The Turks and Caicos Islands',
  },
  {
    value: '+688',
    cn: '图瓦卢',
    en: 'Tuvalu',
  },
  {
    value: '+256',
    cn: '乌干达',
    en: 'Uganda',
  },
  {
    value: '+380',
    cn: '乌克兰',
    en: 'Ukraine',
  },
  {
    value: '+971',
    cn: '阿拉伯联合酋长国',
    en: 'United Arab Emirates',
  },
  {
    value: '+44',
    cn: '联合王国',
    en: 'The United Kingdom',
  },
  {
    value: '+1',
    cn: '美国',
    en: 'The United States',
  },
  {
    value: '+1',
    cn: '美国小离岛',
    en: 'American Outlying Islands',
  },
  {
    value: '+598',
    cn: '乌拉圭',
    en: 'Uruguay',
  },
  {
    value: '+998',
    cn: '乌兹别克斯坦',
    en: 'Uzbekistan',
  },
  {
    value: '+678',
    cn: '瓦努阿图',
    en: 'Vanuatu',
  },
  {
    value: '+58',
    cn: '委内瑞拉',
    en: 'Venezuela',
  },
  {
    value: '+84',
    cn: '越南',
    en: 'Vietnam',
  },
  {
    value: '+1284',
    cn: '维尔京群岛,英国',
    en: 'The Virgin Islands, United Kingdom',
  },
  {
    value: '+1340',
    cn: '维尔京群岛,美国',
    en: 'Virgin Islands, United States',
  },
  {
    value: '+681',
    cn: '瓦利斯群岛和富图纳群岛',
    en: 'The Wallis and Futuna Islands',
  },
  {
    value: '+212',
    cn: '西撒哈拉',
    en: 'Western Sahara',
  },
  {
    value: '+967',
    cn: '也门',
    en: 'Yemen',
  },
  {
    value: '+260',
    cn: '赞比亚',
    en: 'Zambia',
  },
  {
    value: '+263',
    cn: '津巴布韦',
    en: 'Zimbabwe',
  },
]

export const currency = [
  'CNY',
  'USD',
  'EUR',
  'GBP',
  'LEU',
  'JPY',
  'THB',
  'MYR',
  'BRL',
  'KRW',
  'INR',
  'PLN',
  'MVR',
  'AUD',
  'NZD',
  'VND',
  'IDR',
  'CLF',
  'CAD',
  'TRY',
  'TWD',
  'ARS',
  'PKR',
  'KWD',
  'HKD',
  'RUB',
  'ALL',
  'DZD',
  'AFN',
  'AWG',
  'OMR',
  'AZN',
  'EGP',
  'ETB',
  'EEK',
  'AOA',
  'XCD',
  'PGK',
  'BSD',
  'PYG',
  'ILS',
  'BHD',
  'PAB',
  'BYR',
  'BGN',
  'XOF',
  'ISK',
  'BOB',
  'BWP',
  'BZD',
  'BIF',
  'KPW',
  'DKK',
  'DOP',
  'ERN',
  'XPF',
  'PHP',
  'FJD',
  'CVE',
  'GMD',
  'XAF',
  'COP',
  'CRC',
  'CUC',
  'GYD',
  'KZT',
  'HTG',
  'HNL',
  'DJF',
  'GNF',
  'GHC',
  'KHR',
  'ZWD',
  'KYD',
  'KMF',
  'HRK',
  'KES',
  'LVL',
  'LSL',
  'LRD',
  'LYD',
  'LTL',
  'CHF',
  'RWF',
  'RON',
  'MGA',
  'MTL',
  'MWK',
  'MKD',
  'MUR',
  'MRO',
  'PEN',
  'MDL',
  'MAD',
  'MZN',
  'MXN',
  'NAD',
  'ZAR',
  'NIO',
  'NGN',
  'NOK',
  'SEK',
  'SVC',
  'WST',
  'SLL',
  'SCR',
  'STD',
  'SHP',
  'SKK',
  'SZL',
  'SDD',
  'SRD',
  'SBD',
  'TZS',
  'TOP',
  'TTD',
  'TND',
  'VUV',
  'GTQ',
  'VEB',
  'UGX',
  'UAH',
  'UYU',
  'HUF',
  'JMD',
  'ZMK',
  'CLP',
  'MOP',
  'SGD',
  'AED',
]
